export default "__VITE_ASSET__DJK1jLHp__"